import apiClient from "./apiClient";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

export interface CreateExportJobParams {
  reportType: string;
  format: "csv" | "pdf";
  filters: {
    outletId?: string;
    registerId?: string;
    dateFrom?: string;
    dateTo?: string;
  };
  emailDelivery?: boolean;
  userEmail?: string;
}

export interface ExportJob {
  id: string;
  company_id: string;
  user_id: string;
  report_type: string;
  format: string;
  status: "queued" | "processing" | "completed" | "failed";
  file_path?: string;
  error_message?: string;
  created_at: string;
  updated_at: string;
}

export async function createExportJob(
  companyId: string,
  params: CreateExportJobParams,
): Promise<ExportJob> {
  const response = await apiClient.post(
    `/api/companies/${companyId}/export-jobs`,
    params,
  );
  return response.job;
}

export async function pollJobStatus(
  companyId: string,
  jobId: string,
): Promise<ExportJob> {
  const response = await apiClient.get(
    `/api/companies/${companyId}/export-jobs/${jobId}`,
  );
  return response.job;
}

export function getDownloadUrl(companyId: string, jobId: string): string {
  const token = localStorage.getItem("accessToken");
  return `${API_BASE_URL}/api/companies/${companyId}/export-jobs/${jobId}/download?token=${encodeURIComponent(token || "")}`;
}

export async function downloadExportFile(
  companyId: string,
  jobId: string,
): Promise<void> {
  const url = getDownloadUrl(companyId, jobId);
  const a = document.createElement("a");
  a.href = url;
  a.download = "";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export async function listJobs(
  companyId: string,
  filters?: { status?: string; limit?: number },
): Promise<ExportJob[]> {
  const params = new URLSearchParams();
  if (filters?.status) params.append("status", filters.status);
  if (filters?.limit) params.append("limit", filters.limit.toString());

  const response = await apiClient.get(
    `/api/companies/${companyId}/export-jobs?${params.toString()}`,
  );
  return response.jobs || [];
}

export default {
  createExportJob,
  pollJobStatus,
  getDownloadUrl,
  downloadExportFile,
  listJobs,
};
